import React, { useEffect, useState } from "react";
import { Phone, ExternalLink, Search } from "lucide-react";
import { DEALERS, DEALER_ENQUIRE_URL, DEALER_BANNER } from "../data";
import { footerInfo } from "../mock";

const Dealers = () => {
  const [q, setQ] = useState("");
  const { marketedBy } = footerInfo;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const filtered = DEALERS.filter((d) => {
    const s = q.toLowerCase();
    return (
      d.name.toLowerCase().includes(s) ||
      d.city.toLowerCase().includes(s) ||
      d.state.toLowerCase().includes(s)
    );
  });

  return (
    <main>
      <section className="relative bg-black text-white py-16 text-center px-4 overflow-hidden">
        <img
          src={DEALER_BANNER}
          alt="Dealers"
          className="absolute inset-0 w-full h-full object-cover opacity-30"
        />
        <div className="relative">
          <h1 className="heading-font text-4xl md:text-6xl tracking-wide">DEALERS LIST</h1>
          <p className="text-gray-200 mt-3 max-w-2xl mx-auto">
            In addition to below we have multiple vendors (more than 100) who buy selective products
            from us. May it be our popular SC1 or our Waterproof grease.
          </p>
        </div>
      </section>

      <section className="max-w-[1100px] mx-auto px-4 md:px-8 py-12">
        {/* Search */}
        <div className="flex items-center gap-2 border border-gray-300 px-4 py-2 mb-6 max-w-md focus-within:border-[#ED1C24] transition-colors">
          <Search size={18} className="text-gray-500" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search by store, city or state"
            className="flex-1 outline-none text-sm"
          />
        </div>

        <div className="overflow-x-auto border border-gray-200">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-black text-white heading-font tracking-wide text-sm">
                <th className="px-4 py-3">Store Name</th>
                <th className="px-4 py-3">Contact</th>
                <th className="px-4 py-3">City</th>
                <th className="px-4 py-3">State</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((d, i) => (
                <tr key={i} className="border-t border-gray-100 hover:bg-gray-50 transition-colors">
                  <td className="px-4 py-3 heading-font">{d.name}</td>
                  <td className="px-4 py-3">
                    <a href={`tel:${d.contact.replace(/\s/g, "")}`} className="inline-flex items-center gap-1 text-gray-700 hover:text-[#ED1C24]">
                      <Phone size={13} /> {d.contact}
                    </a>
                  </td>
                  <td className="px-4 py-3 text-gray-700">{d.city}</td>
                  <td className="px-4 py-3 text-gray-700">{d.state}</td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr>
                  <td colSpan={4} className="px-4 py-8 text-center text-gray-500">
                    No dealers match your search.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="mt-14 bg-gray-50 border border-gray-100 p-8 text-center">
          <h3 className="heading-font text-2xl tracking-wide mb-3">
            INTERESTED IN BECOMING A DEALER?
          </h3>
          <p className="text-gray-600 max-w-2xl mx-auto mb-6">
            Enquire below and join the Maxima Racing Oils India network.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href={`tel:${marketedBy.phone.replace(/\s/g, "")}`} className="inline-flex items-center gap-2 heading-font tracking-wide">
              <Phone size={16} className="text-[#ED1C24]" /> {marketedBy.phone}
            </a>
            <a
              href={DEALER_ENQUIRE_URL}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 bg-[#ED1C24] hover:bg-[#c4151c] text-white heading-font tracking-wide px-8 py-3 transition-colors"
            >
              Enquire Now <ExternalLink size={15} />
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Dealers;
